/* global axios */
import ApiClient from './ApiClient';

class AccountAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  createAccount(data) {
    return axios.post(`${this.apiVersion}/accounts`, data);
  }

  // POST: checar o domínio SALVO grava o veredito (é ele que põe o domínio
  // no link do convite).
  webchatDomainCheck(domain) {
    return axios.post(
      `/api/v1/accounts/${this.accountIdFromRoute}/webchat/domain_check`,
      { domain }
    );
  }

  // Quem atende cada caixa WhatsApp (Studio / IA externa / ninguém) — mesma
  // regra do porteiro do webchat, calculada no backend.
  webchatAttendants() {
    return axios.get(
      `/api/v1/accounts/${this.accountIdFromRoute}/webchat/attendants`
    );
  }

  // `inboxId` = a marca PRÓPRIA daquela caixa (conta com duas empresas); sem
  // ele, a marca da conta.
  webchatBrandingShow(inboxId = null) {
    return axios.get(
      `/api/v1/accounts/${this.accountIdFromRoute}/webchat/branding`,
      { params: inboxId ? { inbox_id: inboxId } : {} }
    );
  }

  webchatBranding(formData, inboxId = null) {
    return axios.patch(
      `/api/v1/accounts/${this.accountIdFromRoute}/webchat/branding`,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
        params: inboxId ? { inbox_id: inboxId } : {},
      }
    );
  }

  // Textos, cores, endereço e o liga/desliga da marca própria de uma caixa.
  webchatInboxBrand(inboxId, brand) {
    return axios.patch(
      `/api/v1/accounts/${this.accountIdFromRoute}/webchat/inbox_brand`,
      { inbox_id: inboxId, brand }
    );
  }

  async getCacheKeys() {
    const response = await axios.get(
      `/api/v1/accounts/${this.accountIdFromRoute}/cache_keys`
    );
    return response.data.cache_keys;
  }
}

export default new AccountAPI();
